export default "__VITE_ASSET__C3ATOc2e__"